import { QueryParamConfig, QueryParamConfigMap } from 'serialize-query-params';
import {
  NumericArrayParam,
  useQueryParam,
  useQueryParams,
} from 'react-router-url-params';

type CreateArrayParam = {
  ifNotPresent?: 'null' | 'emptyArray' | undefined;
};

function createArrayParamBase<T>(
  params?: CreateArrayParam,
): QueryParamConfig<T[] | null | undefined, T[] | null | undefined> {
  return {
    ...(NumericArrayParam as any),
    decode: (value: string | (string | null)[] | null | undefined) => {
      if (value === undefined) {
        if (params?.ifNotPresent === 'emptyArray') {
          return [];
        } else if (params?.ifNotPresent === 'null') {
          return null;
        }
      }
      return NumericArrayParam.decode(value);
    },
  };
}

export function createNumericArrayParam(
  params?: CreateArrayParam,
): QueryParamConfig<number[] | null | undefined, number[] | null | undefined> {
  return createArrayParamBase<number>(params);
}

export function createEnumArrayParam<T>(
  params?: CreateArrayParam,
): QueryParamConfig<T[] | null | undefined, T[] | null | undefined> {
  return createArrayParamBase<T>(params);
}

export function useQueryParamsInTab<QPCMap extends QueryParamConfigMap>(
  paramConfigMap: QPCMap,
) {
  const result = useQueryParams(paramConfigMap);
  return result;
  // return useLastDataWhenTabWasActive(result);
}

export function useQueryParamInTab<D, D2 = D>(
  name: string,
  paramConfig?: QueryParamConfig<D, D2>,
) {
  const result = useQueryParam(name, paramConfig);
  return result;
  // return useLastDataWhenTabWasActive(result);
}
